import {createSlice} from '@reduxjs/toolkit';
import {httpPythonGet, httpPythonPost} from '../../util/Rest';

const initialData = {
  clientId: {},
  cliId: {},
  serviceId: {},
  servId: {},
  rateTable: {},
  subTypeLists: {},
  addEdit: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'ViewRateTable',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchClientId: (state, action) => {
      state.clientId = action.payload.data;
      state.cliId = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClients: (state, action) => {
      state.cliId = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postServiceId: (state, action) => {
      state.serviceId = action.payload.data;
      state.servId = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getservices: (state, action) => {
      state.servId = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postAddData: (state, action) => {
      state.addEdit = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.msg;
    },
    rateTableData: (state, action) => {
      state.rateTable = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
    },
    subTypesData: (state, action) => {
      state.subTypeLists = action.payload.data;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
      state.accountLegalStatus = null;
    },
    resetMessage: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, fetchError, fetchClientId, postServiceId, rateTableData, postAddData, subTypesData, getservices, getClients, resetMessage} = slice.actions;

export const fetchingClientId = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonGet('/getList')
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchClientId(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getClientIds = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonGet('/getList')
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClients(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postServiceIds = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonPost('/getList', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postServiceId(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getServiceIDs = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonPost('/getList', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getservices(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const postRateTable = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonPost('/getRateTable', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(rateTableData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const getSubtypeList = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonPost('/getRateTable', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(subTypesData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postAddRateTable = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonPost('/addRates', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postAddData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
